import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import FileUpload from '../../../components/ui/FileUpload';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LogoUploadSection = ({ currentLogo, onLogoChange, onLogoRemove }) => {
  const [previewUrl, setPreviewUrl] = useState(currentLogo);

  const handleLogoUpload = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreviewUrl(reader?.result);
      onLogoChange(file, reader?.result);
    };
    reader?.readAsDataURL(file);
  };

  const handleRemoveLogo = () => {
    setPreviewUrl(null);
    onLogoRemove();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-lg font-semibold text-text-primary mb-1">Company Logo</h3>
          <p className="text-sm text-text-secondary">
            Upload your company logo for brand consistency across the visualizer
          </p>
        </div>
        {previewUrl && (
          <Button
            variant="outline"
            size="sm"
            onClick={handleRemoveLogo}
            iconName="Trash2"
            iconPosition="left"
            iconSize={14}
          >
            Remove
          </Button>
        )}
      </div>

      {previewUrl ? (
        <div className="flex items-center gap-6">
          <div className="w-32 h-32 bg-muted rounded-lg border-2 border-border flex items-center justify-center overflow-hidden">
            <Image
              src={previewUrl}
              alt="Company logo preview showing uploaded brand identity"
              className="max-w-full max-h-full object-contain"
            />
          </div>
          <div className="flex-1">
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="CheckCircle" size={16} className="text-success" />
                <span className="text-text-primary font-medium">Logo uploaded successfully</span>
              </div>
              <p className="text-xs text-text-secondary">
                Your logo will appear in the visualizer header and customer-facing pages
              </p>
            </div>
          </div>
        </div>
      ) : (
        <FileUpload
          accept="image/png,image/jpeg,image/svg+xml"
          maxSize={2097152}
          onUpload={handleLogoUpload}
          description="PNG, JPG or SVG (max 2MB). Recommended size: 200x200px"
          label=""
          error=""
        />
      )}

      <div className="mt-4 p-3 bg-muted/50 rounded-lg">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} className="text-text-secondary mt-0.5" />
          <div className="text-xs text-text-secondary">
            <p className="font-medium mb-1">Logo Guidelines:</p>
            <ul className="space-y-1 list-disc list-inside">
              <li>Use transparent background for best results</li>
              <li>Square or horizontal orientation works best</li>
              <li>High resolution ensures clarity on all devices</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoUploadSection;